import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import globalDataReducer from './globalData/globalDataSlice';
import SalaryReducer from '../v2/features/salarycalculator/salary.slice';
import contactReducer from '../v2/features/contact/contact.slice';
import newsReducer from '../v2/features/news/news.slice';
import healthInsuranceReducer from '../v2/features/health-insurance/health-insurance.slice';
import signupReducer from '../v2/features/signup/signup.slice';
import signinReducer from '../v2/features/signin/signin.slice';
import bankidReducer from '../v2/features/bankid/bankid.slice';
import forgetPasswordReducer from '../v2/features/forget-password/forget-password.slice';
import setNewPasswordReducer from '../v2/features/set-new-password/set-new-password.slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    globalData: globalDataReducer,
    salary: SalaryReducer,
    contact: contactReducer,
    news: newsReducer,
    healthInsurance: healthInsuranceReducer,
    signup: signupReducer,
    signin: signinReducer,
    bankidAuthFlow: bankidReducer,
    forgetPassword: forgetPasswordReducer,
    setNewPassword: setNewPasswordReducer,
  },
});

export default store;
